
import { defineComponent, ref } from 'vue'
import User from './user/User.vue'
import SystemRolesPermissions from './system_roles_permissions/SystemRolesPermissions.vue'
import canView from '../../../classes/view_checker'

export default defineComponent({
    components: {
        User,
        SystemRolesPermissions,
    },
    setup(){
        const name = ref('Group Admin Settings')
        
        return {
            name,
            canView
        }
    }
});

